import React, { ImgHTMLAttributes } from 'react';

// Game icons (local)
export const GAME_ICONS: Record<string, string> = {
  'minecraft-java': '/icons/games/minecraft-java.png',
  'minecraft-bedrock': '/icons/games/minecraft-bedrock.png',
  terraria: '/icons/games/terraria.png',
  valheim: '/icons/games/valheim.png',
  ark: '/icons/games/ark.png',
  rust: '/icons/games/rust.png',
  cs2: '/icons/games/cs2.png',
  palworld: '/icons/games/palworld.png',
  satisfactory: '/icons/games/satisfactory.png',
  factorio: '/icons/games/factorio.png',
  hytale: '/icons/games/hytale.png',
};

export interface GameIconProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  gameId: string;
  name?: string;
  className?: string;
}

export const GameIcon: React.FC<GameIconProps> = ({ gameId, name, className = 'w-10 h-10', ...rest }) => {
  const [error, setError] = React.useState(false);
  const iconUrl = GAME_ICONS[gameId];

  if (error || !iconUrl) {
    return (
      <div className={`${className} bg-dark-700 rounded-lg flex items-center justify-center text-white font-bold text-lg`}>
        {name?.charAt(0) || '🎮'}
      </div>
    );
  }

  return (
    <img
      src={iconUrl}
      alt={name}
      className={`${className} object-cover rounded-lg`}
      onError={() => setError(true)}
      {...rest}
    />
  );
};

export interface GameDefinition {
  id: string;
  name: string;
  port: number;
  protocol: string;
}

export const GAMES: GameDefinition[] = [
  { id: 'minecraft-java', name: 'Minecraft Java', port: 25565, protocol: 'TCP' },
  { id: 'minecraft-bedrock', name: 'Minecraft Bedrock', port: 19132, protocol: 'TCP+UDP' },
  { id: 'terraria', name: 'Terraria', port: 7777, protocol: 'TCP' },
  { id: 'valheim', name: 'Valheim', port: 2456, protocol: 'TCP+UDP' },
  { id: 'hytale', name: 'Hytale', port: 5520, protocol: 'UDP' },
  { id: 'rust', name: 'Rust', port: 28015, protocol: 'TCP+UDP' },
  { id: 'cs2', name: 'Counter-Strike 2', port: 27015, protocol: 'TCP+UDP' },
  { id: 'palworld', name: 'Palworld', port: 8211, protocol: 'TCP+UDP' },
  { id: 'satisfactory', name: 'Satisfactory', port: 7777, protocol: 'TCP+UDP' },
  { id: 'factorio', name: 'Factorio', port: 34197, protocol: 'UDP' },
];

